module.exports = __webpack_public_path__ + "static/25-b56ad7057d230aef58d94058e253a3d0.png";